export const SkillSelfServiceMode = {
  Off: 'OFF',
  AddRemoveOnly: 'ADD_REMOVE_ONLY',
  FullSelfService: 'FULL_SELF_SERVICE',
} as const;

export type SkillSelfServiceModeValue =
  (typeof SkillSelfServiceMode)[keyof typeof SkillSelfServiceMode];

export function resolveEffectiveMode(
  skillMode: string | null | undefined,
): SkillSelfServiceModeValue {
  const raw = skillMode || SkillSelfServiceMode.FullSelfService;
  if (raw === SkillSelfServiceMode.Off) return SkillSelfServiceMode.Off;
  if (raw === SkillSelfServiceMode.AddRemoveOnly)
    return SkillSelfServiceMode.AddRemoveOnly;
  return SkillSelfServiceMode.FullSelfService;
}

export function canSelfAddRemove(
  selfServiceMode: string | null | undefined,
): boolean {
  return resolveEffectiveMode(selfServiceMode) !== SkillSelfServiceMode.Off;
}

export function canSelfRate(
  selfServiceMode: string | null | undefined,
): boolean {
  return (
    resolveEffectiveMode(selfServiceMode) ===
    SkillSelfServiceMode.FullSelfService
  );
}
